/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { formatFecha, accessAPI, Boton, Titulo, useEstetica } from "../../shared";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import edad0a3 from "../../images/etiquetaJuguetes0-3.jpg";
import edad0a5 from "../../images/etiquetaJuguetes0-5.jpg";
import edad0a8 from "../../images/etiquetaJuguetes0-8.jpg";
import edad0a10 from "../../images/etiquetaJuguetes0-10.jpg";
import edad0a12 from "../../images/etiquetaJuguetes0-12.jpg";
import logoHorizontalChico from "../../images/logoHorizontalChico.png";

import html2canvas from "html2canvas";

export default function DisenoEtiqueta({ configuracion }) {
  const [loaderDatosCliente, setLoaderDatosCliente] = useState(true);
  const [datosImportador, setDatosImportador] = useState();
  const toast = useRef(null);
  const estetica = useEstetica();

  // La etiqueta va sobre fondo blanco, así que corresponde el horizontal a
  // color del organismo; el de la plataforma queda solo como fallback.
  const logoEtiqueta = estetica?.logos?.horizontal || logoHorizontalChico;

  // Cuando carga el componente, va a buscar los datos del importador para mostrarlos
  useEffect(() => {
    accessAPI(
      "GET",
      "cliente/cliente",
      null,
      (respuesta) => {
        setDatosImportador(respuesta);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar datos del importador",
          life: 3000,
        });
      }
    );
  }, []);

  // Cuando recibe los datos del importador, apaga el loader
  useEffect(() => {
    if (datosImportador) {
      setLoaderDatosCliente(false);
    }
  }, [datosImportador]);

  // Función que descarga el diseño de la etiqueta
  function descargarEtiqueta() {
    const etiqueta = document.getElementById("disenoEtiqueta");

    // useCORS: el logo del organismo se sirve desde el origen de la API; sin
    // esto html2canvas lo omite del PNG descargado.
    html2canvas(etiqueta, { useCORS: true })
      .then((canvas) => {
        canvas.style.display = "none";
        document.body.appendChild(canvas);
        return canvas;
      })
      .then((canvas) => {
        const image = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.setAttribute(
          "download",
          `Etiqueta marcado juguete - ${formatFecha(new Date())}.png`
        );
        a.setAttribute("href", image);
        a.click();
        canvas.remove();
      })
      .catch((error) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            "Error al generar la etiqueta. Por favor, intente nuevamente.",
          life: 3000,
        });
      });
  }
  return (
    <>
      <Toast ref={toast} position="top-center" />
      {/* En web la deja fija el contenedor (.p-gen-modelo) mientras se
          recorren las preguntas */}
      <Card css={{ marginBottom: "1em" }}>
        <Titulo>Modelo de la etiqueta</Titulo>
        <div id="disenoEtiqueta">
          {configuracion[0] === "1" && (
            <img
              src={edad0a3}
              css={{
                width: "130px",
              }}
              alt="0-3"
            />
          )}
          {configuracion[0] === "2" && (
            <img
              src={edad0a5}
              css={{
                width: "130px",
              }}
              alt="0-5"
            />
          )}
          {configuracion[0] === "3" && (
            <img
              src={edad0a8}
              css={{
                width: "130px",
              }}
              alt="0-8"
            />
          )}
          {configuracion[0] === "4" && (
            <img
              src={edad0a10}
              css={{
                width: "130px",
              }}
              alt="0-10"
            />
          )}
          {configuracion[0] === "5" && (
            <img
              src={edad0a12}
              css={{
                width: "130px",
              }}
              alt="0-12"
            />
          )}

          {configuracion[0] === "1" && !configuracion[28] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> No conveniente para niños menores de 3 años.
            </div>
          )}
          {configuracion[0] === "2" && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> No conveniente para niños menores de 5 años.
            </div>
          )}
          {configuracion[0] === "3" && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> No conveniente para niños menores de 8 años.
            </div>
          )}
          {configuracion[0] === "4" && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> No conveniente para niños menores de 10 años.
            </div>
          )}
          {configuracion[0] === "5" && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> No conveniente para niños menores de 12 años.
            </div>
          )}

          {configuracion[28] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> No convenientes para niños menores de 3 años.
              Contiene partes pequeñas.
            </div>
          )}
          {configuracion[16] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Utilizar con un equipo de protección.
            </div>
          )}
          {configuracion[25] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Para evitar el peligro de asfixia, mantener esta
              bolsa lejos del alcance de los niños.
            </div>
          )}
          {configuracion[26] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Este envase contiene broches. Retirar antes de
              entregar el juguete al niño.
            </div>
          )}
          {configuracion[1] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> este juguete no es un equipo salvavidas.
              <br /> <b>Cuidado:</b> usar solamente en aguas donde el niño pueda
              mantenerse en pie y esté bajo supervisión de un adulto.
            </div>
          )}
          {configuracion[2] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Los niños se pueden asfixiar por un globo sin
              inflar o por partes de un globo dañado. Los adultos deben inflar
              los globos y supervisar su uso en niños menores de 6 años.
              Descartar inmediatamente los globos dañados.
            </div>
          )}

          {configuracion[30] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Este juguete es o contiene una pelota pequeña
              que presenta el riesgo de que los niños pueda ahogarse. No
              conveniente para niños menores de 3 años.
            </div>
          )}

          {configuracion[31] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Este juguete es o contiene una bolita que
              presenta el riesgo de que los niños pueda ahogarse. No conveniente
              para niños menores de 3 años.
            </div>
          )}
          {configuracion[19] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> No debe utilizarse cerca de las líneas
              eléctricas o durante una tormenta.
            </div>
          )}
          {configuracion[20] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> No utilizar en vía pública sin la supervisión de
              un adulto.
            </div>
          )}
          {configuracion[22] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Utilizar bajo la supervisión de un adulto.
            </div>
          )}
          {configuracion[24] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> No debe ser utilizado por niños menores a 36
              meses.
            </div>
          )}
          {configuracion[3] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> No apuntar a los ojos y a la cara. No utilizar
              proyectiles distintos a los provistos.
            </div>
          )}
          {configuracion[18] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> No es recomendable disparar en lugares cerrados
              o cerca de los ojos y de los oídos. No llevar fulminantes sueltos
              en los bolsillos.
            </div>
          )}
          {configuracion[23] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Juguete con ruido elevado. Debe ser utilizado a
              más de un metro de distancia del oído. Un mal uso puede causar
              problemas de audición.
            </div>
          )}
          {configuracion[17] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Este producto fue diseñado para ser instalado en
              cunas, camas o cochecitos. Debe ser instalado de acuerdo con las
              instrucciones. No debe ser entregado suelto al niño. Para evitar
              que el niño pueda enredarse y lastimarse, retirar el juguete
              cuando el niño empiece a levantarse sobre las manos y rodillas.
            </div>
          )}
          {configuracion[21] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Esto es un juguete. No proporciona protección.
            </div>
          )}
          {configuracion[4] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ATENCIÓN!</b> Sólo para niños mayores de 5 años. Utilizar bajo
              la vigilancia de un adulto. Leer las instrucciones antes de la
              utilización, seguirlas, conservarlas y observarlas como
              referencia.
            </div>
          )}
          {configuracion[5] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Solo para niños mayores de 5 años. Utilizar
              bajo vigilancia de un adulto.
              <br />
              <b>¡ATENCIÓN!</b> Leer las instrucciones antes de la utilización,
              seguirlas, conservarlas y observarlas como referencia.
            </div>
          )}
          {configuracion[6] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Solo para niños mayores de 8 años. Utilizar
              bajo vigilancia de un adulto.
              <br />
              <b>¡ATENCIÓN!</b> Leer las instrucciones antes de la utilización,
              seguirlas, conservarlas y observarlas como referencia.
            </div>
          )}
          {configuracion[7] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Solo para niños mayores de 10 años. Utilizar
              bajo vigilancia de un adulto.
              <br />
              <b>¡ATENCIÓN!</b> Leer las instrucciones antes de la utilización,
              seguirlas, conservarlas y observarlas como referencia.
            </div>
          )}
          {configuracion[8] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Solo para niños mayores de 5 años.
              <br />
              <b>¡ATENCIÓN!</b> Leer las instrucciones antes de la utilización,
              seguirlas, conservarlas y observarlas como referencia.
            </div>
          )}
          {configuracion[9] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Solo para niños mayores de 12 años. Utilizar
              bajo vigilancia de un adulto.
              <br />
              <b>¡ATENCIÓN!</b> Leer las instrucciones antes de la utilización,
              seguirlas, conservarlas y observarlas como referencia.
            </div>
          )}
          {configuracion[10] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Sólo para niños mayores de 3 años. Utilizar
              bajo vigilancia de un adulto.
            </div>
          )}
          {configuracion[11] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Sólo para niños mayores de 3 años. Utilizar
              bajo vigilancia de un adulto.
            </div>
          )}
          {configuracion[12] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Solo para niños mayores de 12 años. Utilizar
              bajo vigilancia de un adulto.
              <br />
              <b>¡ATENCIÓN!</b> Leer las instrucciones antes de la utilización,
              seguirlas, conservarlas y observarlas como referencia.
            </div>
          )}
          {configuracion[13] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Sólo para niños mayores de 3 años. Utilizar
              bajo vigilancia de un adulto.
            </div>
          )}
          {configuracion[14] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Solo para niños mayores de 8 años. Utilizar
              bajo vigilancia de un adulto.
              <br />
              <b>¡ATENCIÓN!</b> Leer las instrucciones antes de la utilización,
              seguirlas, conservarlas y observarlas como referencia.
            </div>
          )}
          {configuracion[15] && (
            <div
              css={{
                fontFamily: "sans-serif",
                marginBottom: "10px",
              }}
            >
              <b>¡ADVERTENCIA!</b> Solo para niños mayores de 8 años. Utilizar
              bajo vigilancia de un adulto.
              <br />
              <b>¡ATENCIÓN!</b> Leer las instrucciones antes de la utilización,
              seguirlas, conservarlas y observarlas como referencia.
            </div>
          )}
          {loaderDatosCliente && configuracion[27] && (
            <div
              css={{
                fontFamily: "sans-serif",
                fontSize: "12px",
                marginTop: "10px",
                padding: "10px",
              }}
            >
              <Skeleton
                width="100%"
                height="1rem"
                css={{ marginBottom: "0.5rem" }}
              />
              <Skeleton
                width="80%"
                height="1rem"
                css={{ marginBottom: "0.5rem" }}
              />
              <Skeleton width="90%" height="1rem" />
            </div>
          )}
          {configuracion[27] && !loaderDatosCliente && datosImportador && (
            <div>
              <div>
                <span css={{ color: "var(--grisTextos)" }}>
                  Importado por:{" "}
                </span>
                {datosImportador.razonsocial}
              </div>
              <div>
                <span css={{ color: "var(--grisTextos)" }}>RUT: </span>
                {datosImportador.rut}
              </div>
              <div>
                <span css={{ color: "var(--grisTextos)" }}>Dirección: </span>
                {datosImportador.direccion}
              </div>
            </div>
          )}
          {configuracion[29] && (
            <div>
              <div>
                <span css={{ color: "var(--grisTextos)" }}>Código: </span>
                {configuracion[29]}
              </div>
            </div>
          )}
          <img
            src={logoEtiqueta}
            alt={estetica?.nombre || "logo"}
            crossOrigin="anonymous"
            css={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "120px",
              marginTop: "10px",
            }}
          />
        </div>
        <Divider />
        <Boton callback={descargarEtiqueta} ancho>
          Descargar etiqueta
        </Boton>
      </Card>
    </>
  );
}
